// Quick Docs — starred document folders only, on the right of My Desk.
import type { JSX } from 'preact';
import { PinnedBoard } from './PinnedBoard';

export function QuickDocs({ chromeless = false }: { chromeless?: boolean } = {}): JSX.Element {
  return (
    <PinnedBoard
      kind="folder"
      title="Quick Docs"
      empty="Nothing pinned."
      testId="quick-docs"
      className="quick-docs"
      chromeless={chromeless}
    />
  );
}
